





import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Editor as TipTapEditor, EditorContent } from '@tiptap/vue-2';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Link from '@tiptap/extension-link';
import Strike from '@tiptap/extension-strike';
import Underline from '@tiptap/extension-underline';
import Superscript from '@tiptap/extension-superscript';
import Text from '@tiptap/extension-text';
import type { ITextContentDoc, IMergeValues, IField } from '@getaccept/editor-lib';
import {
  ParagraphNode,
  BulletListNode,
  OrderedListNode,
  NoHeadingDocNode,
  NoHeadingListItemNode,
  MergeValueNode,
  HardBreakNode,
} from '@getaccept/editor-lib';
import { updateMergeValues, setContent, handleInit } from '../helpers/prosemirror-viewer.helper';

@Component({
  components: {
    EditorContent,
  },
})
export default class PricingTableDescriptionInput extends Vue {
  @Prop() content: ITextContentDoc;
  @Prop() mergeValues: IMergeValues;
  @Prop() fields: IField[];

  @Watch('fields')
  @Watch('mergeValues')
  watchMergeValueUpdates() {
    updateMergeValues(this.contentPayload);
  }
  @Watch('content') watchContent() {
    setContent(this.contentPayload);
  }

  viewer: TipTapEditor | null = null;

  get contentPayload() {
    return {
      viewer: this.viewer,
      content: this.content,
      fields: this.fields,
      mergeValues: this.mergeValues,
    };
  }

  get inputViewer() {
    return {
      content: this.content,
      enableInputRules: false,
      enablePasteRules: false,
      editable: false,
      extensions: [
        NoHeadingDocNode,
        ParagraphNode,
        Text,
        Bold,
        Italic,
        Strike,
        Superscript,
        Underline,
        OrderedListNode,
        BulletListNode,
        NoHeadingListItemNode,
        Link.configure({
          autolink: false,
          openOnClick: true,
          linkOnPaste: false,
        }),
        MergeValueNode,
        HardBreakNode,
      ],
      onCreate: () => handleInit(this.viewer, this.fields, this.mergeValues),
    };
  }

  mounted() {
    this.viewer = new TipTapEditor(this.inputViewer);
  }

  beforeDestroy() {
    this.viewer.destroy();
  }
}
